import { AnyAction } from 'redux';

import { ContentPlacement } from '@candu-ai/placement/types';

import { SET_PLACEMENTS } from './constants';

export interface PlacementsState {
  placements?: ContentPlacement[];
}

export const initialState: PlacementsState = {
  placements: undefined,
};

export const placementsReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_PLACEMENTS:
      return { ...state, placements: action.placements };
    default:
      return state;
  }
};
